
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/technology-consulting",
      function () {
        return require("private-next-pages/services/technology-consulting.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/technology-consulting"])
      });
    }
  